export default __webpack_public_path__ + "static/media/github.b28d14fe.png";